import { isCSMHelpCenter } from '@atlassian/help-center-common-util/advanced-help-center';
import { getEnv } from '@atlassian/help-center-common-util/env';

export const getApplicationType = () => {
	return {
		applicationType: isCSMHelpCenter(getEnv().helpCenterType) ? 'jcs' : 'jsm',
	};
};
